import type { TipoCambio } from '../features/catalogo/datos'

/**
 * Modo demostración: se activa al compilar con VITE_DEMO=belleza (npm run build:demo -w tienda). La tienda corre
 * entera en el navegador con un catálogo de ejemplo y un servidor simulado; no habla con Supabase.
 */
export const DEMO: string = import.meta.env.VITE_DEMO ?? ''
export const esDemo = DEMO !== ''

/** Tipo de cambio de ejemplo para convertir los precios en dólares (no es una cotización real). */
export const TIPO_CAMBIO_DEMO: TipoCambio = { usdMxn: 18.5, fecha: '2026-10-21' }
